import { FONT_SIZE, FONT_WEIGHT, FONT_FAMILY } from '../../../styles/themes/constants';
import { Typography } from 'antd';
import styled from 'styled-components';

interface ValueTextProps {
  $color: 'success' | 'error';
}

export const Title = styled(Typography.Title)`
  &.ant-typography {
    margin-bottom:10;

    font-size: ${FONT_SIZE.md};
  }
`;

export const Text = styled(Typography.Text)`
  font-size: ${FONT_SIZE.xs};

  font-weight: ${FONT_WEIGHT.regular};

  font-family: ${FONT_FAMILY.secondary};

  margin-top: 1.5rem;
`;

export const ValueText = styled(Typography.Text)<ValueTextProps>`
  font-size: ${FONT_SIZE.xs};

  font-family: ${FONT_FAMILY.secondary};

  color: ${(props) => `var(--${props.$color}-color)`};
`;

export const Icons = styled.div`
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  display: flex;
  flex-wrap: nowrap;

  svg {
    font-size: 1.2rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    color: $color
  }
`;

export const Avatar = styled.div`
  margin-left: -0.5rem;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  display: flex;
  flex-wrap: nowrap;

  svg {
    font-size: 1.5rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`;
